import { VideoStatus, VideoVisibility } from 'js/src/client';
import type { RootState } from 'js/src/libs/RootState';

/* SELECTORS  */
export function isVideoRendering(state: RootState) {
    const status = state.shareVideo.video?.status;
    return status === VideoStatus.QUEUED || status === VideoStatus.PROCESSING;
}

export function selectVideoVisibility(state: RootState) {
    return state.shareVideo.video?.visibility || VideoVisibility.UNLISTED;
}

export const selectVideoProjectId = (state: RootState): number | null => {
    return state.shareVideo.video?.project_id ?? null;
};

export const selectVideoWorkspaceId = (state: RootState): number | undefined => {
    return state.shareVideo.video?.workspace_id;
};
